import {
  useEffect,
  useState
} from "react";

import MainLayout
from "../../components/layout/MainLayout";

import {
  getReportsDashboard
}
from "../../api/reportsApi";

import {
  FaBoxes,
  FaCubes,
  FaTruck,
  FaUsers,
  FaIndustry,
  FaFileInvoice
}
from "react-icons/fa";

const ReportsDashboard = () => {

  const [data,setData] =
  useState({});

  useEffect(()=>{

    loadData();

  },[]);

  const loadData =
  async()=>{

    const res =
    await getReportsDashboard();

    setData(
      res.data.data
    );

  };

  const cards = [

    {
      title:"Materials",
      value:data.materials,
      icon:<FaBoxes />
    },

    {
      title:"Products",
      value:data.products,
      icon:<FaCubes />
    },

    {
      title:"Suppliers",
      value:data.suppliers,
      icon:<FaTruck />
    },

    {
      title:"Customers",
      value:data.customers,
      icon:<FaUsers />
    },

    {
      title:"Production",
      value:data.production,
      icon:<FaIndustry />
    },

    {
      title:"Dispatch",
      value:data.dispatch,
      icon:<FaFileInvoice />
    }

  ];

  return(

    <MainLayout>

      <div className="row">

        {
          cards.map(
            (card,index)=>(

              <div
                key={index}
                className="col-md-4 mb-4"
              >

                <div className="card shadow-sm border-0">

                  <div className="card-body">

                    <h5>

                      {card.icon}

                      {" "}

                      {card.title}

                    </h5>

                    <h2>

                      {card.value || 0}

                    </h2>

                  </div>

                </div>

              </div>

            )
          )
        }

      </div>

    </MainLayout>

  );

};

export default ReportsDashboard;